import baseUrl from "services/api";
import {
  FindBKPsParms,
  FindResultsBKPsTypes,
  FindServicesTypes,
} from "types/services";

interface BuscaBKPsProps {
  typeSearch: "S" | "N";
  page: number;
}

export async function FindCardsServicesFunctions(): Promise<FindServicesTypes> {
  const response = await baseUrl.get("/service/cardsServices");

  return response.data;
}

export async function FindResultsBKPFunction(): Promise<FindResultsBKPsTypes> {
  const response = await baseUrl.get("/service/resultsBKP");

  return response.data;
}

export async function FindBKPsByParmFunction(parms: FindBKPsParms) {
  const response = await baseUrl.get(`/service/BKPs`, {
    params: parms,
  });

  return response.data;
}

export async function BuscaBKPs({ typeSearch, page }: BuscaBKPsProps) {
  const response = await baseUrl.get(
    `/service/BKPs?realizado=${typeSearch}&page=${page}`
  );

  return response.data;
}
